import {ID, Response} from '../../../../../../../_metronic/helpers'
export type User = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  username?: string;
  firstname?: string;
  lastname?: string;
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  } 
}

export type UsersQueryResponse = Response<Array<User>>

export const initialUser: User = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: ''
}

export interface IUsers {
  id?:ID;
  uuid?: string;
  username?: string;
  firstname?: string;
  lastname?: string;
  email?: string;
  password?: string;
  confirm_password?: string;
  device_name?: string;
}


export const UsersInitValues: IUsers = {
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  confirm_password: '',
  device_name: '',

}

export interface ActionPlans {
  id?: number;
  uuid?: string;
  conditioning_id?: number;
  provider_id?: number;
  responsible?: string;
  description?: string; 
  action_plan_cost?: string,
  number_months?: number,
  email_responsible?: string,
  predicted_date?: string,
  conclusion_date?: string,
  status?: any, 
 
  conditioning?: {
    id: number;
    uuid: string;   
    provider_id: 41,
    conditioning_number: string,
    license: {
      id: number,
      uuid: string,     
      license_number: string
    }
  
  },
  responsibles?: [
    {
      id: number,      
      username: string,
      firstname: string,       
    }
  ],
  provider?: {
    id: number,
    uuid: string,
    name: string,   
  }, 

  action_plan_files?: [
    {
      name?: string
      size?: string
    }
  ],

  actionPlanAlertDay?: any[
  ]

  
}

export type ActionPlansQueryResponse = Response<Array<ActionPlans>>

export const ActionPlansInitValues: ActionPlans = {
  description: '',   
}
